module.exports = __webpack_public_path__ + "img/nextone.09edf6bd.png";